import { navigationConfig } from '../config/navigation.config';

export interface INavRequestOptionEdges {
    value: string;          // aus config e.g. GehoertZu
    uiText: string;         // aus config.dictionary e.g. gehört zu
    search: boolean;        // legt fest, ob Bestandteil der Suche -> http.ReqeuestHeader
}

export interface INavRequestOption {
    input: string;
    edges: INavRequestOptionEdges[];
    maxnodes: number;
    loadOptions: string;
    inDepth?: number;
    outDepth?: number;
}

export const NAV_REQUEST_OPTIONS_INITIAL_STATE: INavRequestOption = {
    input: '',
    edges: [],
    maxnodes: navigationConfig.loadRequestMaxElements,
    loadOptions: 'graph'
};



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/nav/model/nav-request-option.interface.ts